export default __webpack_public_path__ + "static/media/register_device_bg.29d4755f.jpg";